export default __webpack_public_path__ + "static/media/logoRata.249fdd37.png";